<template>
    <div>
        <Breadcrumb></Breadcrumb>
        <!-- <div class="common-limit line-height-40">
            <div class="form-body">
                <el-form ref="queryParams" :model="queryParams" label-width="80px">
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="申请编号：" prop="inviter">
                                <el-input size="small" v-model="queryParams.inviter" clearable />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="订单编号：" prop="inviter">
                                <el-input size="small" v-model="queryParams.inviter" clearable />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="主账号：" prop="createBy">
                                <el-input size="small" v-model="queryParams.createBy" clearable />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="生产厂家：" prop="userType">
                                <el-select style="width: 100%" clearable size="small" v-model="queryParams.userType">
                                    <template v-for="(value, key) in dictData['user_type']">
                                        <el-option :key="value.value" :label="value.label" :value="value.value"></el-option>
                                    </template>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="申请人：" prop="inviter">
                                <el-input size="small" v-model="queryParams.inviter" clearable />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item style="width: 100%" label="申请时间：" prop="time">
                                <el-date-picker size="small" v-model="time" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" start-placeholder="开始时间" end-placeholder="结束时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="状态：" prop="status">
                                <el-select style="width: 100%" clearable size="small" v-model="queryParams.status">
                                    <template v-for="(value, key) in dictData['sys_normal_disable']">
                                        <el-option :key="value.value" :label="value.label" :value="value.value"></el-option>
                                    </template>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16" class="btn-bar-right">
                            <el-button type="primary" size="small" @click="loadData">搜索</el-button>
                            <el-button size="small" @click="resetForm">重置</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div> -->
        <div class="form-body">
            <pagination class="bottom-sticky" v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="loadData" />

            <el-table :data="tableData" border>
                <el-table-column width="169" label="申请编号" prop="applyId"></el-table-column>
                <el-table-column width="169" label="订单编号" prop="appNo"> </el-table-column>
                <el-table-column label="主账号" prop="pOperNo"> </el-table-column>
                <el-table-column label="生产厂商" prop="manufacturer"></el-table-column>
                <el-table-column width="120" label="订单主图" prop="mainPic">
                    <template slot-scope="scope">
                        <el-popover
                            placement="right"
                            trigger="hover"
                            :close-delay="0"
                        >
                            <img
                            class="img-big"
                            width="300px"
                            height="300px"
                            :src="scope.row.mainPic ? scope.row.mainPic : noImage"
                            />
                            <img
                            slot="reference"
                            class="img-big"
                            width="100px"
                            height="100px"
                            :src="scope.row.mainPic ? scope.row.mainPic : noImage"
                            />
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="申请人" prop="operNo"></el-table-column>
                <el-table-column width="169" label="申请时间" prop="createTime"></el-table-column>
                <el-table-column width="169" label="审核时间" prop="auditTime"></el-table-column>
                <el-table-column label="状态" prop="status">
                    <template slot-scope="scope">
                        <div>{{ scope.row.status == "01" ? "退货申请" : (scope.row.status == "02"?"退货到库":"审核拒绝") }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="60" fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status == '01'" type="text" size="mini" @click="handleEdit(scope.row)">审核</el-button></template>
                </el-table-column>
            </el-table>
            <pagination class="bottom-sticky" v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="loadData" />
        </div>

        <el-dialog :close-on-click-modal="false" title="审核" :visible.sync="dialogVisible">
            <div>
                <el-form ref="form" :model="form" size="small" label-width="160px">
                    <el-form-item label="审核结果：">
                        <el-radio-group v-model="form.status">
                            <template>
                                <el-radio label="02">通过</el-radio>
                                <el-radio label="03">不通过</el-radio>
                            </template>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="审核意见：">
                        <el-input type="textarea" v-model="form.auditOpinion"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button size="small" @click="dialogVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { refundApplyList, editRefundApply } from "@/api/order/all"
import noImage from "@/assets/images/no_image.png"

export default {
    components: { Breadcrumb },
    data() {
        return {
            // // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 2,
                // beginTime: undefined,
                // endTime: undefined,
                // userType: "01",
                // status: undefined,//状态
                // createBy: "",//主账号
                // inviter: "",
                // // 申请编号
                // // 订单编号
                // // 生产厂家
                // // 申请人
            },
            // time: [],
            total: 0,
            tableData: [],
            dialogVisible: false,
            form: {
                applyId:"",
                status:"02",
                auditOpinion:""
            },
            noImage: noImage,
        }
    },
    computed: {
        ...mapGetters(["dictData"]),
    },
    created() {
        // this.getCache("1")
        this.loadData()
    },
    methods: {
        /* 获取列表数据 */
        loadData() {
            this.startLoading()
            // this.setCache("1")
            // let params = JSON.parse(JSON.stringify(this.queryParams))

            // if (this.time && this.time.length > 0) {
            //     params.beginTime = this.time[0]
            //     params.endTime = this.time[1]
            // } else {
            //     params.beginTime = undefined
            //     params.endTime = undefined
            // }
            refundApplyList(this.queryParams)
                .then((res) => {
                    this.endLoading()
                    this.total = res.total
                    this.tableData = res.rows
                })
                .catch((err) => {
                    this.endLoading()
                    console.error(err)
                })
        },
        // resetForm() {
        //     this.$refs["queryParams"].resetFields()
        // },
        handleEdit(row) {
            this.dialogVisible = true
            this.$nextTick(() => {
                this.$refs["form"].resetFields()
                this.form.applyId = row.applyId
            })
        },
        handleSave() {
            let _self = this
            editRefundApply(_self.form).then((res) => {
                if (res.code == "200") {
                    _self.msgSuccess("审核成功！")
                    _self.dialogVisible = false
                    _self.loadData()
                } else {
                    _self.msgError("审核失败！")
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.btn-bar-right {
    text-align: right;
}
</style>